// extracted by mini-css-extract-plugin
module.exports = {"modalOfferIcon":"offermodalheromobile_modalOfferIcon__4XpGM","blueBackground":"offermodalheromobile_blueBackground__Evcec","offerLegal":"offermodalheromobile_offerLegal__MhrKi"};